<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import afiliacionSistemaRiesgosAPI from "@/services/standards/afiliacionSistemaRiesgos/afiliacionSistemaRiesgosAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import AfiliacionSistemaRiesgosPagination from "../../../components/standard/afiliacionSistemaRiesgos/AfiliacionSistemaRiesgosPagination.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "1.1.4 Afiliación al Sistema General de Riesgos Laborales ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
    Multiselect,
    AfiliacionSistemaRiesgosPagination,
  },
  data() {
    return {
      title: "1.1.4 Afiliación al Sistema General de Riesgos Laborales ",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.1.4 Afiliación al Sistema General de Riesgos Laborales ",
          active: true,
        },
      ],
      lista: [],

      file: null,
      lastId: 1,
      deleteCount: 0,
      search: '',

      periodMonth: null,
      periodYear: null,
      months: [
        { value: "01", text: "Enero" },
        { value: "02", text: "Febrero" },
        { value: "03", text: "Marzo" },
        { value: "04", text: "Abril" },
        { value: "05", text: "Mayo" },
        { value: "06", text: "Junio" },
        { value: "07", text: "Julio" },
        { value: "08", text: "Agosto" },
        { value: "09", text: "Septiembre" },
        { value: "10", text: "Octubre" },
        { value: "11", text: "Noviembre" },
        { value: "12", text: "Diciembre" },
      ],

      validationResult: null,
      showValidationModal: false,
      validationConfirmed: false,
      validating: false,
      pendingSavePath: null,
      summaryModalData: null,
      showSummaryModal: false,

      afiliacion: {
        contract_type: null,
        select_period: null,
        file: null,
        observations: null,
        employee_id: [],
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      afiliacionContratista: {
        contract_type: null,
        select_period: null,
        file: null,
        observations: null,
        employee_id: [],
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      trainingList: [],
      employee: [],

      submitted: false,

      nit: this.$store.getters["company/getCompany"].nit || null,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,

      user: this.$store.state.auth || null,

      loading1: true,
      loading2: true,
      loading3: true,

      item: null,
      selected: [],
      allSelected: false,
      userIds: [],
      itemStatus: "No cumplido",

      itemData: null,

      optionss: ["Vuex", "Vue", "Vuelidate", "Vue-Multiselect", "Vue-Router"],

      options: [
        {
          id: 1,
          description: "Planta",
        },
        {
          id: 3,
          description: "Contratista",
        },
        {
          id: 2,
          description: "Aprendiz",
        },
      ],
    };
  },
  validations: {
    program: {
      induction_date: {
        required,
      },
      induction_theme: {
        required,
      },
    },
  },

  computed: {
    years() {
      const currentYear = new Date().getFullYear();
      const list = [];
      for (let y = currentYear + 1; y >= currentYear - 5; y--) {
        list.push(y);
      }
      return list;
    },
    allEmpleadosSelected() {
      return (
        this.employee.length > 0 &&
        this.employee.every((dato) =>
          this.afiliacion.employee_id.includes(dato.id)
        )
      );
    },
    allContratistasSelected() {
      return (
        this.trainingList.length > 0 &&
        this.trainingList.every((dato) =>
          this.afiliacion.employee_id.includes(dato.id)
        )
      );
    },
  },

  methods: {
    updatePeriod() {
      if (this.periodMonth && this.periodYear) {
        this.afiliacion.select_period = `${this.periodYear}-${this.periodMonth}`;
      } else {
        this.afiliacion.select_period = null;
      }
    },
    toggleAllEmpleados(checked) {
      this.afiliacion.employee_id = checked
        ? this.employee.map((dato) => dato.id)
        : [];
    },
    toggleAllContratistas(checked) {
      this.afiliacion.employee_id = checked
        ? this.trainingList.map((dato) => dato.id)
        : [];
    },
    selectAll: function () {
      this.userIds = [];
      if (this.allSelected) {
        for (user in this.employee) {
          this.userIds.push(this.employee[user].id.toString());
        }
      }
    },
    select: function () {
      this.allSelected = false;
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItemData() {
      ItemAPI.getItems(10)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = ""
        let contractName = ""
        if (this.afiliacion.contract_type === 1) {
          contractName = "Empleado"
        } else if (this.afiliacion.contract_type === 2) {
          contractName = "Empleado-Aprendiz"
        } else {
          contractName = "Contratista"
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/1.1.4/${contractName}/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/1.1.4/${contractName}/${this.lastId}/${this.file.name}`;
        }

        const result = await uploadDocument(url, this.file);
        if (result) {
          this.afiliacion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleSaveClick() {
      if (!this.file) {
        Swal.fire({
          title: "Archivo requerido",
          text: "Selecciona la planilla de pago antes de continuar.",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        })
        return
      }
      if (!this.afiliacion.contract_type) {
        Swal.fire({
          title: "Tipo de contrato requerido",
          text: "Selecciona el tipo de contrato antes de continuar.",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        })
        return
      }
      if (!this.afiliacion.employee_id || this.afiliacion.employee_id.length === 0) {
        Swal.fire({
          title: "Colaboradores requeridos",
          text: "Selecciona al menos un colaborador antes de continuar.",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        })
        return
      }

      this.submitted = true
      this.validating = true
      try {
        const result = await afiliacionSistemaRiesgosAPI.validatePayroll(
          this.file,
          this.companyID,
          this.afiliacion.contract_type
        )
        this.validating = false

        if (!result || result.message === "Unauthenticated.") {
          Swal.fire({
            title: "Error",
            text: "No se pudo validar la planilla.",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          })
          this.submitted = false
          return
        }

        this.validationResult = result

        if (result.unparseable) {
          const confirm = await Swal.fire({
            title: "Validación no disponible",
            text: result.message,
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Guardar sin validar",
            cancelButtonText: "Cancelar",
            confirmButtonClass: "btn btn-primary mt-2",
            cancelButtonClass: "btn btn-secondary mx-1 mt-2",
          })
          if (confirm.isConfirmed) {
            this.validationResult = null
            this.afiliacion.validation_summary = null
            await this.save()
          } else {
            this.submitted = false
          }
          return
        }

        if (result.has_warnings) {
          this.validationConfirmed = false
          this.showValidationModal = true
        } else {
          await this.proceedWithSave()
        }
      } catch (error) {
        this.validating = false
        this.submitted = false
        console.log(error)
        Swal.fire({
          title: "Error",
          text: "Ocurrió un problema al validar la planilla.",
          icon: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        })
      }
    },

    async proceedWithSave() {
      this.showValidationModal = false
      this.afiliacion.validation_summary = this.validationResult
      await this.save()
    },

    cancelValidation() {
      this.showValidationModal = false
      this.submitted = false
      this.validationResult = null
      this.validationConfirmed = false
    },

    viewValidationSummary(summary) {
      this.summaryModalData = summary
      this.showSummaryModal = true
    },

    async save() {
      this.loading1 = true
      this.submitted = true
      let response = await this.uploadDocument();
      if (response) {
        afiliacionSistemaRiesgosAPI.saveMulti(this.afiliacion).then((response) => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 4,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "Éxito",
                  text: "¡Se ha registrado con éxito!",
                  icon: "success",
                  type: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });

          this.loading1 = false
          setTimeout(() => {
            Swal.fire({
              title: "Éxito",
              text: "¡Se ha registrado con éxito!",
              icon: "success",
              style: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });

            window.location.reload();
          }, 1000);
        })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "Error",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    async saveContratista() {
      this.loading1 = true
      this.submitted = true
      let response = await this.uploadDocument();
      if (response) {
        afiliacionSistemaRiesgosAPI.save(this.afiliacion)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 4,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Éxito",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "Error",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          // Si el SST no devuelve la empresa, terminar el loading igual.
          if (!response || !response.uuid) {
            this.loading1 = false;
            return;
          }
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r && r.nit ? r.nit : null;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
              this.loading1 = false;
            });
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 4)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/Formato/1.2.2-Lista-de-asistencia.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      afiliacionSistemaRiesgosAPI
        .getAll(this.companyID)
        .then((response) => {
          this.loading = false;
          let identification = response.data.data;
          this.lista = identification;
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }

          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getContratistas() {
      afiliacionSistemaRiesgosAPI
        .getContratistas(this.companyID)
        .then((response) => {
          this.loading = false;
          this.trainingList = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getEmpleados() {
      afiliacionSistemaRiesgosAPI
        .getEmpleados(this.companyID)
        .then((response) => {
          this.loading = false;
          this.employee = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 4,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 1000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    deleteafiliacion(id) {
      afiliacionSistemaRiesgosAPI
        .delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 4,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "Se ha sido eliminado con exito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

  },

  mounted() {
    this.getData();
    this.getItems();
    this.getItemData();
    this.getContratistas();
    this.getEmpleados();
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1 && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Todos los colaboradores, independiente de su forma de
                      vinculación deben estar afiliados a la seguridad social,
                      incluyendo la ARL y mensualmente se deben hacer los
                      aportes acordes con su nivel de riesgo.
                    </p>
                    <p class="text-justify">
                      El responsable de la implementación del SG SST debe
                      verificar que se realicen estos aportes y subir las
                      planillas correspondientes.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right m-b-0"></div>
              </div>
              <div class="row">
                <div class="col-md-6 col-sm-12"></div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="handleSaveClick">
                <div class="form-row col-12">
                  <b-form-group class="col-md-6 px-2" label="Tipo de contrato" label-for="theme">
                    <b-form-select :disabled="!getRole('Crear')" required id="theme" v-model="afiliacion.contract_type"
                      :class="{
                        'is-invalid':
                          $v.program.induction_theme.$error && submitted,
                      }">
                      <b-form-select-option v-for="(item, index) in options" :key="index" :value="item.id">
                        {{ item.description }}
                      </b-form-select-option>
                    </b-form-select>
                    <div v-if="submitted && $v.program.induction_theme.$error">
                      <small v-if="!$v.program.induction_theme.required" class="text-danger">
                        <b>El tema de capacitación es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group v-if="afiliacion.contract_type === 3" class="col-md-6 px-2" label-for="theme">
                    <table
                      class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded style=overflow-y: scroll;">
                      <thead>
                        <tr>
                          <th>Seleccionar contratista</th>

                          <th class="text-center align-middle">
                            <input type="checkbox" :checked="allContratistasSelected"
                              @change="toggleAllContratistas($event.target.checked)" title="Seleccionar todos"
                              class="mb-1" />
                            <div><small>Todos</small></div>
                          </th>
                        </tr>
                      </thead>

                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-for="dato in trainingList" :key="dato.id">
                          <td>
                            {{ dato.full_name }}
                          </td>
                          <td class="text-center align-middle">
                            <input type="checkbox" style="color: #666" :value="dato.id" v-model="afiliacion.employee_id"
                              class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div v-if="submitted && $v.program.induction_theme.$error">
                      <small v-if="!$v.program.induction_theme.required" class="text-danger">
                        <b>El tema de capacitación es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group v-if="afiliacion.contract_type === 1 ||
                    afiliacion.contract_type === 2
                  " class="col-md-6 px-2" label-for="theme">
                    <table
                      class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded style=overflow-y: scroll;">
                      <thead>
                        <tr>
                          <th>Seleccionar empleados</th>

                          <th class="text-center align-middle">
                            <input type="checkbox" :checked="allEmpleadosSelected"
                              @change="toggleAllEmpleados($event.target.checked)" title="Seleccionar todos"
                              class="mb-1" />
                            <div><small>Todos</small></div>
                          </th>
                        </tr>
                      </thead>

                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-for="dato in employee" :key="dato.id">
                          <td>
                            {{ dato.full_name }}
                          </td>
                          <td class="text-center align-middle">
                            <input type="checkbox" style="color: #666" :value="dato.id" v-model="afiliacion.employee_id"
                              class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-form-group>
                </div>

                <div class="form-row col-12">

                  <b-form-group class="col-md-6 px-2" label="Seleccionar período">
                    <div class="form-row">
                      <div class="col-6">
                        <b-form-select :disabled="!getRole('Crear')" v-model="periodMonth" @change="updatePeriod">
                          <b-form-select-option :value="null" disabled>Mes</b-form-select-option>
                          <b-form-select-option v-for="m in months" :key="m.value" :value="m.value">
                            {{ m.text }}
                          </b-form-select-option>
                        </b-form-select>
                      </div>
                      <div class="col-6">
                        <b-form-select :disabled="!getRole('Crear')" v-model="periodYear" @change="updatePeriod">
                          <b-form-select-option :value="null" disabled>Año</b-form-select-option>
                          <b-form-select-option v-for="y in years" :key="y" :value="y">
                            {{ y }}
                          </b-form-select-option>
                        </b-form-select>
                      </div>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Subir evidencia de pago de ARL" label-for="file">
                    <b-form-file :disabled="!getRole('Crear')" id="file" ref="file" name="file" browse-text="Buscar"
                      :placeholder="`Selecciona un archivo PDF o Excel...`" drop-placeholder="Suelta acá..." v-model="file"
                      @change="uploadFile" v-on:change="uploadFile"
                      accept=".pdf,.xlsx,.xls,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!getRole('Crear')" id="description" v-model="afiliacion.observations">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted || validating" type="submit" class="btn btn-primary">
                    <span v-if="validating">
                      <b-spinner small></b-spinner> Validando planilla...
                    </span>
                    <span v-else>Guardar</span>
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar')">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">
                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Periodo</th>
                              <th class="text-center align-middle">
                                Colaborador
                              </th>
                              <th class="text-center align-middle">
                                Tipo de contrato
                              </th>
                              <th class="text-center align-middle">
                                Validación
                              </th>
                              <th class="text-center align-middle">
                                Ver archivo
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dato.select_period }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.full_name }}
                              </td>
                              <td class="text-center align-middle">
                                <div v-if="dato.contract_type === 1">
                                  Planta
                                </div>
                                <div v-if="dato.contract_type === 2">
                                  Aprendiz
                                </div>
                                <div v-if="dato.contract_type === 3">
                                  Contratista
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <span
                                  v-if="dato.validation_status === 'ok'"
                                  class="badge badge-success"
                                  style="cursor: pointer;"
                                  @click="viewValidationSummary(dato.validation_summary)"
                                  title="Ver detalle"
                                >
                                  OK
                                </span>
                                <span
                                  v-else-if="dato.validation_status === 'warnings'"
                                  class="badge badge-warning text-dark"
                                  style="cursor: pointer;"
                                  @click="viewValidationSummary(dato.validation_summary)"
                                  title="Ver detalle"
                                >
                                  Con advertencias
                                </span>
                                <span v-else class="badge badge-light text-muted">
                                  Sin validar
                                </span>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                      background-color: transparent !important;
                                      border: none;
                                    " type="button" @click="gotoDigitalOcean(`${dato.file}`)">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " :to="{
                                        path: `/forms/estandares/afiliacion-sistema-riesgos-ver/${dato.id}`,
                                      }">
                                      Ver</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " v-b-modal="`modal${dato.id}`">Editar</b-dropdown-item>

                                    <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">
                                          Advertencia
                                        </h4>
                                        <p class="mt-3">
                                          Al modificar esta información se
                                          quitará el puntaje correspondiente a
                                          este ítem y será necesario realizar
                                          nuevamente la validación por parte del
                                          usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()
                                          " type="button" class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white" :to="{
                                            path: `/forms/estandares/afiliacion-sistema-riesgos-editar/${dato.id}`,
                                          }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="
                                          $bvModal.hide(`modal${dato.id}`)
                                          " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                          Cancelar
                                        </button>
                                      </div>
                                    </b-modal>

                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deleteafiliacion(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <AfiliacionSistemaRiesgosPagination ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->

    <b-modal
      v-model="showValidationModal"
      title="⚠️ Inconsistencias detectadas en la planilla"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <div v-if="validationResult">
        <div
          v-if="(validationResult.paid_but_inactive || []).length"
          class="alert alert-danger small"
        >
          <strong>⚠️ Se detectó pago de seguridad social a empleado(s) inactivo(s).</strong>
          La planilla incluye cédulas de personas que ya aparecen como inactivas en la empresa.
          Revisa el detalle antes de confirmar.
        </div>
        <div class="alert alert-warning small">
          La planilla cargada no coincide completamente con los empleados activos
          de la empresa para el tipo de contrato seleccionado. Revisa el detalle antes de confirmar.
        </div>

        <div class="row mb-3 text-center">
          <div class="col-6 col-md-3">
            <h6 class="text-success mb-0">{{ validationResult.ok.length }}</h6>
            <small class="text-muted">OK</small>
          </div>
          <div class="col-6 col-md-3">
            <h6 class="text-danger mb-0">{{ validationResult.missing_in_payroll.length }}</h6>
            <small class="text-muted">Activos sin aporte</small>
          </div>
          <div class="col-6 col-md-3">
            <h6 class="text-danger mb-0">{{ (validationResult.paid_but_inactive || []).length }}</h6>
            <small class="text-muted">Pagados pero inactivos</small>
          </div>
          <div class="col-6 col-md-3">
            <h6 class="text-warning mb-0">{{ validationResult.unknown_in_payroll.length }}</h6>
            <small class="text-muted">Sobrantes</small>
          </div>
        </div>

        <div v-if="(validationResult.paid_but_inactive || []).length" class="mb-3">
          <strong class="text-danger small">Empleados inactivos con aporte en la planilla</strong>
          <table class="table table-sm table-bordered border-danger mt-1 mb-0">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Documento</th>
                <th>Cargo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="emp in validationResult.paid_but_inactive" :key="'i-' + emp.id" class="table-danger">
                <td>{{ emp.full_name }}</td>
                <td>{{ emp.identification_number }}</td>
                <td>{{ emp.position }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="validationResult.missing_in_payroll.length" class="mb-3">
          <strong class="text-danger small">Empleados activos sin aporte en la planilla</strong>
          <table class="table table-sm table-bordered mt-1 mb-0">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Documento</th>
                <th>Cargo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="emp in validationResult.missing_in_payroll" :key="'m-' + emp.id">
                <td>{{ emp.full_name }}</td>
                <td>{{ emp.identification_number }}</td>
                <td>{{ emp.position }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="validationResult.unknown_in_payroll.length" class="mb-3">
          <strong class="text-warning small">Cédulas en la planilla sin empleado registrado en la empresa</strong>
          <table class="table table-sm table-bordered mt-1 mb-0">
            <thead>
              <tr>
                <th>Documento en planilla</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in validationResult.unknown_in_payroll" :key="'u-' + idx">
                <td>{{ row.identification_number }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <hr />

        <b-form-checkbox v-model="validationConfirmed" class="mb-3">
          He revisado las inconsistencias y confirmo que la información es correcta
          y se debe guardar de todas formas.
        </b-form-checkbox>

        <div class="text-right">
          <button type="button" class="btn btn-secondary mx-1" @click="cancelValidation">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="!validationConfirmed"
            @click="proceedWithSave"
          >
            Confirmar y guardar
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showSummaryModal"
      title="Detalle de validación de la planilla"
      size="lg"
      hide-footer
    >
      <div v-if="summaryModalData">
        <div class="row mb-3 text-center">
          <div class="col-6 col-md-3">
            <h6 class="text-success mb-0">{{ (summaryModalData.ok || []).length }}</h6>
            <small class="text-muted">OK</small>
          </div>
          <div class="col-6 col-md-3">
            <h6 class="text-danger mb-0">{{ (summaryModalData.missing_in_payroll || []).length }}</h6>
            <small class="text-muted">Activos sin aporte</small>
          </div>
          <div class="col-6 col-md-3">
            <h6 class="text-danger mb-0">{{ (summaryModalData.paid_but_inactive || []).length }}</h6>
            <small class="text-muted">Pagados pero inactivos</small>
          </div>
          <div class="col-6 col-md-3">
            <h6 class="text-warning mb-0">{{ (summaryModalData.unknown_in_payroll || []).length }}</h6>
            <small class="text-muted">Sobrantes</small>
          </div>
        </div>

        <div v-if="(summaryModalData.paid_but_inactive || []).length" class="mb-3">
          <strong class="text-danger small">Empleados inactivos con aporte en la planilla</strong>
          <table class="table table-sm table-bordered border-danger mt-1 mb-0">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Documento</th>
                <th>Cargo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(emp, idx) in summaryModalData.paid_but_inactive" :key="'si-' + idx" class="table-danger">
                <td>{{ emp.full_name }}</td>
                <td>{{ emp.identification_number }}</td>
                <td>{{ emp.position }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="(summaryModalData.missing_in_payroll || []).length" class="mb-3">
          <strong class="text-danger small">Empleados activos sin aporte</strong>
          <table class="table table-sm table-bordered mt-1 mb-0">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Documento</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(emp, idx) in summaryModalData.missing_in_payroll" :key="'sm-' + idx">
                <td>{{ emp.full_name }}</td>
                <td>{{ emp.identification_number }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="(summaryModalData.unknown_in_payroll || []).length">
          <strong class="text-warning small">Cédulas en planilla no encontradas</strong>
          <table class="table table-sm table-bordered mt-1 mb-0">
            <thead>
              <tr>
                <th>Documento</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in summaryModalData.unknown_in_payroll" :key="'su-' + idx">
                <td>{{ row.identification_number }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
